import { chowlyApi } from 'config'

import client from '../chowly'
import { UserResponse } from '../models'

export const getMyAccount = async () => {
  const { data } = await client.get<UserResponse>(chowlyApi.me)
  return data
}
